import React from "react";
import styled from "styled-components";
import CategorySelect from "./category-select";
import ManufacturerSelect from "./manufacturer-select";
import ModelSelect from "./model-select";
import ModelTypeSelect from "./model-type-select";
import DeckSizeSelect from "./deck-size-select";
import ConfigurationSelect from "./configuration-select";
import { reducer, initialState } from "./reducer";
import OEMBaggerSelect from "./oem-bagger-select";
import YearSelect from "./year-select";
import ProductDetails from "./product-details";

export default function Configurator() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [isMountBarOnly, setIsMountBarOnly] = React.useState(false);
  React.useEffect(() => {
    const configValue =
      document.getElementById("configurator-root").dataset.mountbaronly;
    const isMountBarOnly = /^true$/i.test(configValue);
    if (isMountBarOnly !== undefined) {
      setIsMountBarOnly(isMountBarOnly);
      return;
    }
  }, []);

  return (
    <Container>
      <ConfiguratorBody>
        <form className="jrco-configurator__form flex-form flex-form--stacked">
          <fieldset>
            <div id="div_equipmentCategory" className="selDiv form-field">
              <CategorySelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_manufacturer" className="selDiv form-field">
              <ManufacturerSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_model" className="selDiv form-field">
              <ModelSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_modelType" className="selDiv form-field">
              <ModelTypeSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_deckSize" className="selDiv form-field">
              <DeckSizeSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_unitConfiguration" className="selDiv form-field">
              <ConfigurationSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_bagger" className="selDiv form-field">
              <OEMBaggerSelect state={state} dispatch={dispatch} />
            </div>
            <div id="div_year" className="selDiv form-field">
              <YearSelect state={state} dispatch={dispatch} />
            </div>
          </fieldset>
        </form>
        <div className="jrco-configurator__display">
          <ProductDetails
            state={state}
            dispatch={dispatch}
            isMountBarOnly={isMountBarOnly}
          />
          <div className="jrco-configurator__parts-list"></div>
        </div>
      </ConfiguratorBody>
      <Extras>
        {state.productDetails?.spreaderInformation &&
          state.productDetails.spreaderInformation[0] && (
            <Card>
              <div className="title">Broadcast Spreader</div>
              <div className="body">
                <SpreaderInformation>
                  <p>
                    {state.productDetails.spreaderInformation[0].spreaderNote ||
                      "See product page for more details"}
                  </p>
                  <a
                    href={`/${state.productDetails.spreaderInformation[0].spreaderItemNo_}`}
                    className="btnPri button--small"
                  >
                    Go to Product
                  </a>
                </SpreaderInformation>
              </div>
            </Card>
          )}
        {state.productDetails?.documents &&
          state.productDetails.documents.length > 0 && (
            <Card>
              <div className="title">Available Documents</div>
              <div className="body">
                {state.productDetails.documents.map((document, index) => {
                  console.log(document);
                  return (
                    <span key={index} className="link-wrapper">
                      <a
                        href={document.url}
                        target="_blank"
                        rel="noreferrer"
                        className="linkPri"
                      >
                        {document.title}
                      </a>
                      <span className="link-separator">|</span>
                    </span>
                  );
                })}
              </div>
            </Card>
          )}
        {state.productDetails?.specialInstructions && (
          <Card>
            <div className="title">Special Instructions</div>
            <div className="body">
              {state.productDetails?.specialInstructions}
            </div>
          </Card>
        )}
      </Extras>
    </Container>
  );
}

const ConfiguratorBody = styled.div`
  padding: 0 0 20px;
  display: flex;
  gap: 20px;
  width: 100%;
  margin: 10px 0 0;
  flex-flow: column;

  @media (min-width: 769px) {
    flex-flow: row nowrap;
  }
`;

const Container = styled.div`
  max-width: 800px;
  border: solid 1px var(--color--light-grey);
  border-radius: 8px;
  padding: 5px;
  @media (min-width: 769px) {
    padding: 0 20px 20px 20px;
  }
`;

const Extras = styled.div`
  border-top: solid 1px var(--color--light-grey);
  padding: 20px 0;
  display: flex;
  flex-flow: column;
  gap: 20px;
`;
const Card = styled.div`
  border: 1px solid var(--color--dark-grey);
  border-radius: 8px;

  .title {
    height: 40px;
    background-color: #000;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    line-height: 38px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .body {
    min-height: 65px;
    padding: 10px;
    text-align: left;
  }

  .link-separator {
    color: var(--color--dark-grey);
    font-size: 0.8em;
    margin: 0 5px;
  }

  .link-wrapper:last-of-type .link-separator {
    display: none;
  }
`;

const SpreaderInformation = styled.div`
  display: flex;
  gap: 20px;
  p {
    margin: 0;
  }

  a {
    margin-left: auto;
    align-self: flex-end;
    min-width: 150px;
  }
`;
